module.exports = __webpack_public_path__ + "img/wireless-mail-access.32a892e6.png";